import { useSelector } from 'react-redux';
import { RootState } from '../app/store';

export function useTranslation(): (key: string) => string {
  const translations = useSelector((state: RootState) => state.translation.value);
  function t(key: string): string {
    if (Object.prototype.hasOwnProperty.call(translations, key)) {
      return translations[key];
    }
    return key;
  }
  return t;
}
